import ElementCollection from './index';

const shortHandSelector = (selector, context) => new ElementCollection(selector, context);

export default shortHandSelector;
